// extracted by mini-css-extract-plugin
export default {"card":"confirm-direct-debit-otp_view_card__beuW8","error":"confirm-direct-debit-otp_view_error__K0Tne"};